<template>
    <div id="stepper-margin">
        <v-stepper
            alt-labels
            elevation="0"
            v-model="step"
            v-if="stepOn === false"
        >
            <v-stepper-header>
                <v-stepper-step id="stepper1" step="1" color="orange">
                    <div class="prompt-16" style="color: #9d9b9a" id="step1">
                        {{ $t('message.stepperBar.register')}}
                    </div>
                </v-stepper-step>

                <v-divider id="divide1_off"></v-divider>

                <v-stepper-step id="stepper2_off" step="2" color="orange">
                    <div class="prompt-16 stepper_absolute" style="color: #9d9b9a;" id="step2_off">
                        {{ $t('message.stepperBar.qualifiedCandidates')}}
                    </div>
                </v-stepper-step>

                <v-divider id="divide2_off"></v-divider>

                <v-stepper-step id="stepper3_off" step="3" color="orange">
                    <div class="prompt-16 stepper_absolute" style="color: #9d9b9a;" id="step3_off">
                        {{ $t('message.stepperBar.examinationResult')}}
                    </div>
                </v-stepper-step>

                <v-divider id="divide3_off"></v-divider>

                <v-stepper-step id="stepper4_off" step="4" color="orange">
                    <div class="prompt-16 stepper_absolute" style="color: #9d9b9a" id="step4_off">
                        {{ $t('message.stepperBar.confirmation')}}
                    </div>
                </v-stepper-step>

            </v-stepper-header>
        </v-stepper>
        <v-stepper
            alt-labels
            elevation="0"
            v-model="step"
            v-if="stepOn === true"
        >
            <v-stepper-header>
                <v-stepper-step id="stepper1" step="1" color="orange">
                    <div class="prompt-16" style="color: #9d9b9a" id="step1">
                        {{ $t('message.stepperBar.register')}}
                    </div>
                </v-stepper-step>

                <v-divider id="divide1"></v-divider>

                <v-stepper-step id="stepper2" step="2" color="orange">
                    <div class="prompt-16" style="color: #9d9b9a" id="step2">
                        {{ $t('message.stepperBar.payment')}}
                    </div>
                </v-stepper-step>

                <v-divider id="divide2"></v-divider>

                <v-stepper-step id="stepper3" step="3" color="orange">
                    <div class="prompt-16 stepper_absolute" style="color: #9d9b9a;" id="step3">
                        {{ $t('message.stepperBar.qualifiedCandidates')}}
                    </div>
                </v-stepper-step>

                <v-divider id="divide3"></v-divider>

                <v-stepper-step id="stepper4" step="4" color="orange">
                    <div class="prompt-16 stepper_absolute" style="color: #9d9b9a" id="step4">
                        {{ $t('message.stepperBar.examinationResult')}}
                    </div>
                </v-stepper-step>

                <v-divider id="divide4"></v-divider>

                <v-stepper-step id="stepper5" step="5" color="orange">
                    <div class="prompt-16 stepper_absolute" style="color: #9d9b9a" id="step5">
                        {{ $t('message.stepperBar.confirmation')}}
                    </div>
                </v-stepper-step>
            </v-stepper-header>
        </v-stepper>
    </div>
</template>

<script>
export default {
    name: "StepperBar",
    data: () => ({
        step: 3,
    }),
    props: {
        stepOn: Boolean,
        stepper: Number,
    },
    mounted() {
        this.step = this.stepper;
        document.getElementById("step1").style.color = "#331E00";
        document.getElementById("step1").style.fontWeight = 400;
        document.getElementById(
                    "stepper1"
                ).children[0].style.backgroundColor = "orange";
        if(this.stepOn === true){
            if (this.step > 1) {
                document.getElementById("step2").style.color = "#331E00";
                document.getElementById("step2").style.fontWeight = 400;
                document.getElementById("divide1").style.borderColor = "orange";
            }
            if (this.step > 2) {
                document.getElementById(
                    "stepper2"
                ).children[0].style.backgroundColor = "orange";
                document.getElementById("step3").style.color = "#331E00";
                document.getElementById("step3").style.fontWeight = 400;
                document.getElementById("divide2").style.borderColor = "orange";
            }
            if (this.step > 3) {
                document.getElementById(
                    "stepper3"
                ).children[0].style.backgroundColor = "orange";
                document.getElementById("step4").style.color = "#331E00";
                document.getElementById("step4").style.fontWeight = 400;
                document.getElementById("divide3").style.borderColor = "orange";
            }
            if (this.step > 4) {
                document.getElementById(
                    "stepper4"
                ).children[0].style.backgroundColor = "orange";
                document.getElementById("step5").style.color = "#331E00";
                document.getElementById("step5").style.fontWeight = 400;
                document.getElementById("divide4").style.borderColor = "orange";
            }
        }
        else{
            this.step = this.stepper - 1;
            if (this.step > 1) {
                document.getElementById("step2_off").style.color = "#331E00";
                document.getElementById("step2_off").style.fontWeight = 400;
                document.getElementById("divide1_off").style.borderColor = "orange";
            }
            if (this.step > 2) {
                document.getElementById(
                    "stepper2_off"
                ).children[0].style.backgroundColor = "orange";
                document.getElementById("step3_off").style.color = "#331E00";
                document.getElementById("step3_off").style.fontWeight = 400;
                document.getElementById("divide2_off").style.borderColor = "orange";
            }
            if (this.step > 3) {
                document.getElementById(
                    "stepper3_off"
                ).children[0].style.backgroundColor = "orange";
                document.getElementById("step4_off").style.color = "#331E00";
                document.getElementById("step4_off").style.fontWeight = 400;
                document.getElementById("divide3_off").style.borderColor = "orange";
            }
            if (this.step > 4) {
                document.getElementById(
                    "stepper4_off"
                ).children[0].style.backgroundColor = "orange";
                document.getElementById("step5_off").style.color = "#331E00";
                document.getElementById("step5_off").style.fontWeight = 400;
                document.getElementById("divide4_off").style.borderColor = "orange";
            }
        }
    },
};
</script>

<style lang="scss">
.theme--light.v-sheet.v-stepper {
    background-color: transparent;
    border-color: transparent;
}

.v-stepper__step__step {
    font-family: "prompt";
    font-size: 16px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}

.theme--light.v-stepper .v-stepper__step--active .v-stepper__label {
    text-shadow: 0px 0px 0px transparent;
}

.stepper_absolute{
    position:absolute; 
    width:200px; 
    left:-10px;
}
</style>
